import React from 'react';
import TablaConfgFechasProc from './tablaConfigFechaPro';
import TablaConfgFechasPrq from './tablaConfigFechaProQ';

const TablaConfgFechaspc = () => {

  return (
    <div className="">
      <ul className="nav mb-3 py-3" id="ex-with-icons" role="tablist">
        {/* <li className="nav-item ml-3" role="presentation">
          <a className="nav-link text-dark rounded" style={{ backgroundColor: "#25d366" }} id="ex-with-icons-tab-1" data-mdb-toggle="tab" href="#ex-with-icons-tabs-1" role="tab" aria-controls="ex-with-icons-tabs-1" aria-selected="true"><i className="fas fa-calendar-minus fa-fw me-2" />Fecha Vencimiento Producción</a>
        </li>
        <li className="nav-item" role="presentation">
          <a className="nav-link text-dark rounded" style={{ backgroundColor: "#55acee" }} id="ex-with-icons-tab-2" data-mdb-toggle="tab" href="#ex-with-icons-tabs-2" role="tab" aria-controls="ex-with-icons-tabs-2" aria-selected="false"><i className="fas fa-calendar-day fa-fw me-2" />Fecha Vencimiento Qui/Producción</a>
        </li> */}
      </ul>
      <div className="tab-content" id="ex-with-icons-content" style={{ backgroundColor: '#', height: '100%', width: '100%' }}>
        <div className="tab-pane fade show active" id="ex-with-icons-tabs-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

          <TablaConfgFechasProc />

        </div>
        {/* <div className="tab-pane fade" id="ex-with-icons-tabs-2" role="tabpanel" aria-labelledby="ex-with-icons-tab-2">
          <TablaConfgFechasPrq />
        </div> */}
      </div>
    </div>
  );
}
export default TablaConfgFechaspc;


// WEBPACK FOOTER //
// ./src/components/impuestoprodu/tablaConfigFecha.js